import { render, staticRenderFns } from "./quillEditor.vue?vue&type=template&id=2ff99f4c&scoped=true&"
import script from "./quillEditor.vue?vue&type=script&lang=js&"
export * from "./quillEditor.vue?vue&type=script&lang=js&"
import style0 from "./quillEditor.vue?vue&type=style&index=0&id=2ff99f4c&prod&lang=scss&"
import style1 from "./quillEditor.vue?vue&type=style&index=1&id=2ff99f4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff99f4c",
  null
  
)

export default component.exports